<template>

  <!-- login -->
  <section class="login">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <h2 class="title">{{$t('login_page.log_in')}}</h2>
          <p class="text">{{$t('login_page.text1')}}</p>

          <form action="login" class="main-form needs-validation-login" novalidate="">
            <div class="form-group">
              <label for="code" class="col-form-label">Code</label>
              <input type="text" name="code" id="code" class="form-control col-8" required=""
                     :placeholder="code_placeholder" v-model="code"/>
              <small id="codeOfSetHelpBlock" class="form-text text-muted">{{$t('login_page.code_beneath_scratch')}}</small>
              <div class="invalid-feedback">{{$t('login_page.invalid_code')}}</div>
              <div class="valid-feedback">{{$t('login_page.code_ok')}}</div>
            </div>

            <div class="form-group">
              <label for="password" class="col-form-label">{{$t('password')}}:</label>
              <input type="password" name="password" id="password" class="form-control col-8" required=""
                     :placeholder="password_placeholder" v-model="password"/>
              <div class="invalid-feedback">{{$t('wrong_pass')}}</div>
            </div>

            <div class="row">
              <div class="col">
                <a href="#" @click="login()" class="btn btn-main">{{$t('login_page.log_in')}}</a>
              </div>
            </div>
          </form>
        </div>

        <div class="col-md-6 col-sm-12">
          <h2 class="title">{{$t('login_page.dont_have_account')}}</h2>
          <p class="text">{{$t('login_page.text2')}}</p>

          <div class="row">
            <div class="col">
              <router-link :to="{name:'register-view'}" class="btn btn-dark">{{$t('register_yourself')}}</router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
  import {HANDLE_LOGIN, DISPLAY_MESSAGE, FETCH_USER} from "../store/actions";

  export default {
    name: "Login",
    data() {
      return {
        password_placeholder: this.$t('login_page.enter_password'),
        code_placeholder: this.$t('login_page.collection_set_code'),
        code: '',
        password: '',
        errors: {}
      }
    },
    methods: {
      login() {
        this.$store.dispatch(HANDLE_LOGIN,
          {
            registration_code: this.code,
            password: this.password
          }).then(result => {
          this.$store.dispatch(FETCH_USER);
          this.$router.push({name: 'home-view'})
        }).catch(error => {
          this.code = '';
          this.password = '';
          this.$store.dispatch(DISPLAY_MESSAGE, {
            message: {
              type: 'danger',
              content: this.$t("login_page.wrong_code_or_pass")
            }
          })
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Login.vue